import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LOADINGGIF from './roletaroleta.gif'; 

const LoadingScreen = ({ children }) => {
  const [countdown, setCountdown] = useState(4);
  const [showContent, setShowContent] = useState(false);
  useEffect(() => {
    if (countdown === 0) {
      setShowContent(true);
    } else {
      const timer = setInterval(() => setCountdown((prev) => prev - 1), 1000);
      return () => clearInterval(timer); 
    }
  }, [countdown]);

  if (!showContent) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
          backgroundColor: '#14222F', 
        }}
      >
        <img
          src={LOADINGGIF}
          alt="Loading..."
          style={{ width: '300px', height: '300px', marginBottom: '16px' }} 
        />
        <Typography variant="h6" sx={{ color: '#ffffff' }}>
          {/* Loading... {countdown}s */}
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
};

export default LoadingScreen;
